import React from 'react';

const APropos = (props) => {
  return (
    <div id="apropos" className="text-center">
      <div className="container">
    
        
     <br></br>
     <br></br>
     <br></br>
     <br></br>
                  <h3 className='h3_apropos'>Ce que vous devez savoir :</h3>
                  <br></br>
   <br></br>
                  
                  <p className='p_apropos'>Découvrir Swaly forme</p>
<p className='p_apropos'>C'est se découvrir grâce à des activités physiques. </p>
                  <p className='p_apropos'>Éducatrice sportive, diplômée d’un brevet d’Etat (BPJEPS activité physique pour tous).</p>
                   <p className='p_apropos'> J’accompagnerai  votre quotidien sportif en vous proposant diverses activités, dans le cadre de votre bien-être et de votre épanouissement.</p>
                  <p className='p_apropos'>7 jours sur 7.</p>
                  <br></br>
                  <br></br>
                  <div className='partenaires'>
                    <h3 className='h3_apropos'>Ils me font confiance :</h3>
                    <br></br>
                    <br></br>
                  <img className="partenaires_apropos" src="img/partenaires/cahg.jpeg" alt="" />
                  <img className="partenaires_apropos" src="img/partenaires/ffepgv.jpeg" alt="" />
                  <img className="partenaires_apropos" src="img/partenaires/isae.jpeg" alt="" />
                  <img className="partenaires_apropos" src="img/partenaires/primair.jpeg" alt="" />
                  <img className="partenaires_apropos" src="img/partenaires/uca.jpg" alt="" />
                  </div>
<br></br>
<br></br>



                  <img src='img/apropos.jpg' className="img-responsive" alt="" />

                </div>
              
        
    </div>
  );
};

export default APropos;